export default [
  {
    path: "/CWr9vtL",
    name: "qe26.payments",
    meta: {
      title: "QE Payment(s)",
      authRequired: true,
      acc: [""],
    },
    component: () => import("@/views/qe/tws/payment/index.vue"),
  },
  {
    path: "/Eu7paqy",
    name: "qe26.pin.requests",
    meta: {
      title: "QE Pin Request(s)",
      authRequired: true,
      acc: [""],
    },
    component: () => import("@/views/qe/tws/payment/index2.vue"),
  },
  {
    path: "/0BGufzQgl",
    name: "qe26.pin.transactions",
    meta: {
      title: "QE Transaction",
      authRequired: true,
      acc: ["y961b69z15"],
    },
    component: () => import("@/views/qe/tws/payment/transactions.vue"),
  },
  {
    path: "/YsKRWmlN",
    name: "qe26.pin.requests.transactions",
    meta: {
      title: "QE Pin Request",
      authRequired: true,
      acc: ["y961b69z15"],
    },
    component: () => import("@/views/qe/tws/payment/transactions2.vue"),
  },
];
